<template>
  <footer class="bg-light text-center">
    <div class="p-3">
      Desenvolvido em VueJS por
      <a
        href="https://www.linkedin.com/in/alissonph/"
        target="_blank"
        rel="noreferrer noopener"
        >Alisson Hausmann</a
      >
      |
      <a
        href="https://github.com/alissonph"
        target="_blank"
        rel="noreferrer noopener"
        >GitHub</a
      >
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
footer {
  margin-top: auto;
}
</style>
